import { render, staticRenderFns } from "./BranchCustomersHub.vue?vue&type=template&id=c41cb7b4"
import script from "./BranchCustomersHub.vue?vue&type=script&lang=js"
export * from "./BranchCustomersHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports